import axios from 'axios';
import { CodeList, CodeListKey, CodeListKeyLong, CodeListPrest, FieldConstraint, SalarySimFormCodeList } from '../Model/CodeListOutput';
import {Translation} from '../Model/TranslationOutput';

export const CodeListPrestService = async (url: string) => {

  try {
    const { data } = await axios.get<CodeListPrest>(url + "SalarySim/GetPA5Code",
      {
        headers: {
          Accept: 'application/json',
        },
        timeout:0,
      },
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return error.message;
    }
    else
    {
      return 'An unexpected error occurred';
    }
  }
}

export const CodeListFormService = async (url: string) => {

  try {
    const { data } = await axios.get<SalarySimFormCodeList>(url + "SalarySim/GetFormCodeList",
      {
        headers: {
          Accept: 'application/json',
        },
        timeout:0,
      },
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return error.message;
    }
    else
    {
      return 'An unexpected error occurred';
    }
  }
}

export const JCService = async (url: string, contractKeyValNum: number) => {
  try {
    const { data } = await axios.get<Array<CodeListKeyLong>>(url + "SalarySim/GetJointCom", {
      headers: {
        Accept: 'application/json'
      },
      params: {
        contractType: contractKeyValNum
      },
      timeout: 0
    });
    return data;
  }
  catch(error)
  {
    //Seems those message are ignored and replaced by a generic one so long as the return type is a string
    if (axios.isAxiosError(error)) return error.message;
    else return 'An unexpected error occurred';
  }
}

export const PrefixService = async(url: string, jcValString: string, contractKeyValNum: number) => {
  try {
    const { data } = await axios.get<Array<CodeListKey>>(url + "SalarySim/NSSOPrefix", {
      headers: {
        Accept: 'application/json'
      },
      params: {
        jcValString: jcValString,
        contractType: contractKeyValNum
      },
      timeout: 0
    });
    return data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) return error.message;
    else return 'An unexpected error occurred';
  }
}

export const FieldConstraintsService = async (url: string) => {

  try {
    const { data } = await axios.get<FieldConstraint[]>(url + "SalarySim/GetFieldConstraints",
      {
        headers: {
          Accept: 'application/json',
        },
        timeout:0,
      },
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      return error.message;
    }
    else
    {
      return 'An unexpected error occurred';
    }
  }
}
